/**
 * @typedef {import('./lib/index.js').Options} Options
 * @typedef {import('./lib/index.js').Whitespace} Whitespace
 */

export {toText} from './lib/index.js'
